import { Car } from '~/shared/api'
import { transactionMoveFundsTypeEnumOptions } from '~/shared/config/constants'
import { Filter } from '~/shared/ui/AsyncGrid/types'

export const filters: Filter[] = [
  {
    field: 'appliedAtFrom',
    label: 'filter.period start',
    type: 'date',
  },
  {
    field: 'appliedAtTo',
    label: 'filter.period end',
    type: 'date',
  },
  {
    field: 'moveFundsType',
    label: 'filter.movement type',
    type: 'select',
    options: transactionMoveFundsTypeEnumOptions,
  },
  {
    field: 'flowStatementName',
    label: 'filter.turnover item',
    type: 'text',
  },
  {
    field: 'sourceType',
    label: 'filter.user or source',
    type: 'text',
  },
  {
    field: 'carId',
    label: 'filter.car',
    type: 'autocomplete',
    fetchOptions: Car.fetchOptions,
  },
]
